module.exports = __webpack_public_path__ + "media/images/claim_profile/doctor-0ddbf4d893ff5055e700b22588c4496b.png";